import {Component} from 'panel';

import {getReportUrl} from 'common/report/util';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {ReportName} from 'common/report/constants';
import 'common/components/tag';

import {NavReport} from '../types';
import {NavigationTrackingEvent} from './tracking';
import {template} from './template';

export class ReportsMenu extends Component<EmptyObj> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'current-report-name': `string`,
      open: `boolean`,
      order: `json`,
      'project-id': `number`,
      reports: `json`,
      'workspace-id': `number`,
    };
  }

  get config() {
    return {
      template,
      helpers: {
        getReportUrl,
        ReportName,

        getReports: () => this.attr(`order`).map((r) => this.attr(`reports`)[r]),

        getClassSuffix: (report: NavReport) => {
          // make sure to just use 'messages' from 'triggers/messages' and similar urls
          return (report.endpoint || ``).split(`/`).slice(-1)[0];
        },

        handleDropMenuChange: (ev) => {
          ev.stopImmediatePropagation();
          if (ev.detail.state === `closed`) {
            this.setAttribute(`open`, `false`);
            this.dispatchEvent(new CustomEvent(`closemenu`));
          }
        },

        handleClickReportName: (ev, report) => {
          if (report.disabled) {
            ev.stopImmediatePropagation();
            ev.preventDefault();
            return;
          }

          mixpanel.track(NavigationTrackingEvent.SelectReport, {
            'Nav Source': `Menu Nav`,
            'Report From': this.attr(`current-report-name`),
            'Report To': report.name,
          });
        },
      },
    };
  }
}

export const ReportsMenuEl = defineAndMakeJsxFactory(`mp-reports-menu`, ReportsMenu);
export const ReportsMenuReact = panel2react(`mp-reports-menu`, ReportsMenu);
